import React, { useState } from "react";
import { handleApiError } from "../../../common/utils";
import { toast } from "react-toastify";
import { DownloadModalProps } from "../types/types";
import { downloadBulkIncidentsExcel } from "../services/service";

const Download: React.FC<DownloadModalProps> = ({
  onActionComplete,
  department,
}) => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [downloading, setDownloading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!fromDate || !toDate) {
      toast.error("Please select both from and to dates");
      return;
    }

    try {
      setDownloading(true);

      // Use service function for file download
      const blob = await downloadBulkIncidentsExcel({
        fromDate,
        toDate,
        department,
      });

      // Create a download link and trigger it
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `incidents_${fromDate}_to_${toDate}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      toast.success("Download started");

      // Call the callback if provided
      if (onActionComplete) {
        onActionComplete();
      }
    } catch (error) {
      handleApiError(error, "Failed to download incidents");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="p-3">
          <div className="flex flex-col mb-3">
            <label htmlFor="from-date" className="text-black font-semibold">
              From Date
            </label>
            <input
              type="date"
              id="from-date"
              className="border-2 border-[#7d7f82] w-full px-3 py-2 font-semibold text-[#4e545d]"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              required
            />
          </div>
          <div className="flex flex-col mb-3">
            <label htmlFor="to-date" className="text-black font-semibold">
              To Date
            </label>
            <input
              type="date"
              id="to-date"
              className="border-2 border-[#7d7f82] w-full px-3 py-2 font-semibold text-[#4e545d]"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              required
            />
          </div>
        </div>
        <div className="fixed bottom-0 w-full px-3 py-4 font-semibold bg-[#eef4f8] text-[#566680] flex justify-start">
          <button
            type="submit"
            className="bg-teal-600 text-white py-2 px-10 rounded-full hover:bg-teal-500 disabled:bg-gray-400"
            disabled={downloading}
          >
            {downloading ? "DOWNLOADING..." : "SUBMIT"}
          </button>
        </div>
      </form>
    </>
  );
};

export default Download;
